import { useState, useCallback } from "react";
import { getEmployeeProjects } from "../../api/projectApi";

export default function useEmployeeProjects() {
  const [projects, setProjects] = useState([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchEmployeeProjects = useCallback(async (filters = {}) => {
    try {
      setLoading(true);

      const data = await getEmployeeProjects(filters);

      setProjects(data.results || []);
      setCount(data.count || 0);

      return {
        success: true,
        data: data.results || [],
      };
    } catch (error) {
      console.error("Employee Projects Error:", error);
      return {
        success: false,
      };
    } finally {
      setLoading(false);
    }
  }, []); // Empty dependency array is correct here

  return {
    projects,
    count,
    loading,
    fetchEmployeeProjects,
  };
}